<template>
  <div class="filters">
    <div class="filters__title">refine results</div>
    <template v-if="currentContext === 'Courses'">
      <div @click="updateHiddenFacets('features')" class="filters__facet">
        <span class="filters__highlight"></span>
        <p class="filters__facet-title">
          Features
        </p>
      </div>
      <div
        v-show="!hiddenFacets.includes('features')"
        v-for="feature in featureFilters"
        :key="`filter-wrapper-${feature.name}`"
        class="filters__results-wrapper"
      >
        <template
          v-for="(count, title) in handleResults(feature.name, feature.data)"
        >
          <div
            v-if="title !== 'false'"
            :key="`filter-result-${title}-${count}`"
            class="filters__result"
          >
            <div
              @click="updateFilters({ facet: feature.name, value: title })"
              class="filters__item"
            >
              <input
                class="filters__item--checkbox"
                type="checkbox"
                :checked="checkedFilters.includes(feature.name)"
              />
              <p class="filters__item--title">
                {{ transformFilterTitle(feature.name) }}
              </p>
              <p class="filters__item--count">{{ count }}</p>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-for="facet in nonfeatureFilters">
      <div
        @click="updateHiddenFacets(facet.name)"
        class="filters__facet"
        :key="`filter-${facet.name}`"
      >
        <span class="filters__highlight"></span>
        <p class="filters__facet-title">
          {{ transformFilterTitle(facet.name) }}
        </p>
      </div>
      <div
        v-show="!hiddenFacets.includes(facet.name)"
        :key="`filter-wrapper-${facet.name}`"
        class="filters__results-wrapper"
      >
        <div
          v-for="(count, title) in handleResults(facet.name, facet.data)"
          :key="`filter-result-${title}-${count}`"
          class="filters__result"
        >
          <div
            @click="updateFilters({ facet: facet.name, value: title })"
            class="filters__item"
          >
            <input
              class="filters__item--checkbox"
              type="checkbox"
              :checked="checkedFilters.includes(title)"
            />
            <p class="filters__item--title">{{ title }}</p>
            <p class="filters__item--count">{{ count }}</p>
          </div>
        </div>
        <button
          v-if="isButtonShown(facet.data)"
          @click="updateIsShowingMore(facet.name)"
          class="filters__show-more-btn"
        >
          {{ isShowingMore.includes(facet.name) ? 'show less' : 'show more' }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  props: {
    currentContext: {
      type: String,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
    filters: {
      type: [Array, Object],
      required: true,
    },
    currentRefinedValues: {
      type: Array,
      required: true,
    },
    filterMap: {
      type: Object,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isShowingMore: ['features'],
      hiddenFacets: [],
    }
  },
  computed: {
    featureFilters() {
      const featureFilters = []
      const features = this.isFreeTrialUser
        ? this.features
        : this.features.filter(f => f !== 'has_sample_content')
      if (this.filters && this.filters.length) {
        this.filters.map(filter => {
          if (features.includes(filter.name)) {
            featureFilters.push(filter)
          }
        })
      }
      return featureFilters
    },
    nonfeatureFilters() {
      const nonfeatureFilters = []
      if (this.filters && this.filters.length) {
        this.filters.map(filter => {
          if (!this.features.includes(filter.name)) {
            nonfeatureFilters.push(filter)
          }
        })
      }
      return nonfeatureFilters
    },
    checkedFilters() {
      return this.currentRefinedValues.flat(2)
    },
  },
  methods: {
    transformFilterTitle(filter) {
      return this.filterMap[filter] || filter
    },
    updateHiddenFacets(facet) {
      if (this.hiddenFacets.includes(facet)) {
        this.hiddenFacets = this.hiddenFacets.filter(f => f !== facet)
      } else {
        this.hiddenFacets.push(facet)
      }
    },
    handleResults(facet, results) {
      if (this.isShowingMore.includes(facet)) {
        return Object.keys(results)
          .slice(0, 15)
          .reduce((result, key) => {
            result[key] = results[key]

            return result
          }, {})
      }
      return Object.keys(results)
        .slice(0, 5)
        .reduce((result, key) => {
          result[key] = results[key]

          return result
        }, {})
    },
    isButtonShown(results) {
      return Object.keys(results).length > 5
    },
    updateIsShowingMore(facet) {
      if (this.isShowingMore.includes(facet)) {
        this.isShowingMore = this.isShowingMore.filter(f => f !== facet)
      } else {
        this.isShowingMore.push(facet)
      }
    },
    updateFilters({ facet, value }) {
      this.$emit('updateFilters', { facet, value })
    },
  },
}
</script>

<style lang="scss" scoped>
.filters {
  $this: &;
  display: flex;
  flex-wrap: wrap;
  &__title {
    color: var(--white);
    width: 100%;
    margin: 0 0 30px 0;
    font-size: 1rem;
    text-transform: uppercase;
  }
  &__facet {
    margin: 0 0 10px 0;
    text-transform: uppercase;
    background-color: var(--light-gray);
    display: flex;
    align-items: center;
    padding: 5px 0;
    width: 100%;
    &:hover {
      cursor: pointer;
      #{$this}__highlight {
        background-color: var(--white);
      }
      #{$this}__key:after {
        background: var(--orange);
      }
    }
    @include tablet {
      padding: 15px 0;
    }
  }
  &__facet-title {
    text-transform: capitalize;
    color: var(--white);
    transition: 0.5s all ease;
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0 0 0 15px;
    width: 100%;
    display: flex;
    align-items: center;
    &:after {
      content: '';
      display: block;
      background: var(--white);
      width: 15px;
      height: 3px;
      margin: 0 15px 0 auto;
      transition: 0.5s all ease;
    }
  }
  &__highlight {
    display: none;
    width: 6px;
    height: 27px;
    background-color: var(--orange);
    vertical-align: middle;
    transition: 0.5s all ease;
    @include tablet {
      display: block;
    }
  }
  &__results-wrapper {
    border-radius: 10px;
    margin: 0;
    padding: 0 0 0 5px;
    animation: fadeIn 1s ease-out;
    width: 100%;
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
  &__result {
    width: 100%;
    border-bottom: 1px solid #323232;
    color: var(--white);
    text-transform: capitalize;
    transition: 0.5s all ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    &:hover {
      cursor: pointer;
      color: var(--orange);
    }
    @include tablet {
      padding: 3px;
    }
    &--toggle {
      border: none;
      padding: 0;
    }
  }
  &__item {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    &--checkbox {
      margin: 0 5px;
      appearance: none;
      background: var(--flat-black);
      color: var(--white);
      padding: 10px;
      &:hover {
        cursor: pointer;
      }
      &:checked {
        background: var(--orange);
        color: var(--white);
        position: relative;
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        transform: rotate(45deg);
        @include tablet {
          width: 22px;
          height: 22px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 3px;
          height: 9px;
          background-color: var(--white);
          left: 11px;
          top: 6px;
        }
        &::after {
          content: '';
          position: absolute;
          width: 3px;
          height: 3px;
          background-color: var(--white);
          left: 8px;
          top: 12px;
        }
      }
    }
    &--title {
      font-size: 1rem;
      margin: 0 0 0 10px;
      color: var(--white);
      padding: 0;
    }
    &--count {
      font-size: 1rem;
      margin-left: auto;
      border-radius: 25px;
      color: var(--white);
      padding: 0;
    }
  }
  &__show-more-btn {
    color: var(--white);
    margin: 20px auto 50px auto;
    text-align: center;
    width: auto;
    border: none;
    background: var(--light-gray);
    border-radius: 25px;
    cursor: pointer;
    transition: 0.5s all ease;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    font-size: 0.8rem;
    padding: 5px 15px;
    &:hover {
      opacity: 0.6;
    }
  }
}
</style>
